module.exports = __webpack_public_path__ + "img/100_ways_button.99814986.png";